export default __webpack_public_path__ + "static/media/mercado-final.5a2edc63.png";